var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920.002,
    height: 1183.001,
    viewBox: "0 0 1920.002 1183.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9013fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#480a7f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1920V118.461s-135.388.769-263.081,73.846-148.463,153.953-380,263.076S975.093,511.3,769.236,648.8,566.389,889.431,379.349,979.876,0,1080,0,1080Z",
    fill: "#9013fe",
    opacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1920V119.253s-89.948,6.725-164.464,40.4c-232.135,104.92-213.674,163.511-477.923,330.213s-373.161,70.19-564.1,220.807-188.151,263.58-361.641,362.651c-3.99,2.279-7.983,4.426-12.084,6.671C170.266,1172.8,0,1183,0,1183Z",
    opacity: 0.5,
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1920V118.343s-132.609.595-244.994,49.158C1453.341,263.286,1472.335,295.031,1220,447.219S863.668,511.3,681.334,648.8,501.667,889.431,336,979.876,0,1080,0,1080Z",
    fill: "#12121c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroVector);
export default __webpack_public_path__ + "static/media/hero-vector.5d199502364555d19eba62be25052731.svg";
export { ForwardRef as ReactComponent };